"use client";

import { cn } from "@/lib/utils";

export type BillingPeriod = "monthly" | "annual";

export default function BillingPeriodToggle({
  value,
  onChange,
  monthlyLabel,
  annualLabel,
}: {
  value: BillingPeriod;
  onChange: (value: BillingPeriod) => void;
  monthlyLabel: string;
  annualLabel: string;
}) {
  const options: { value: BillingPeriod; label: string }[] = [
    { value: "monthly", label: monthlyLabel },
    { value: "annual", label: annualLabel },
  ];

  return (
    <div
      className="inline-flex h-10 w-fit shrink-0 rounded-full border border-line/70 bg-white p-1 shadow-[0_1px_2px_rgb(15_23_42/0.04)]"
      role="tablist"
      aria-label="Billing period"
    >
      {options.map((option) => {
        const isActive = value === option.value;

        return (
          <button
            key={option.value}
            type="button"
            role="tab"
            aria-selected={isActive}
            onClick={() => onChange(option.value)}
            className={cn(
              "min-w-[5.25rem] cursor-pointer rounded-full px-4 text-sm font-medium",
              isActive
                ? "bg-foreground text-background"
                : "text-muted-foreground hover:text-foreground",
            )}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
}
